import React from 'react';
import styled from 'styled-components';

import { Payslip } from '../../components/CS20-010-payslip/Payslip/Payslip';

import RouterTrackerForAnalytics from '../../lib/utils/RouterTrackerForAnalytics'; // [MEMO] 구글 애널리틱스 라우터 트래커

const PayslipPage = () => {
  const $title = document.head.querySelector('title');
  $title!.innerText = '급여 명세서';
  RouterTrackerForAnalytics();

  return (
    <>
      <Payslip />
    </>
  );
};

export default PayslipPage;
